export default "__VITE_ASSET__BPi9fxu2__"